import { render } from "./App3Forms.vue?vue&type=template&id=6372cffd&scoped=true"
import script from "./App3Forms.vue?vue&type=script&lang=js"
export * from "./App3Forms.vue?vue&type=script&lang=js"

import "./App3Forms.vue?vue&type=style&index=0&id=6372cffd&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6372cffd"]])

export default __exports__